/* eslint-disable linebreak-style */
import { makeStyles } from '@material-ui/core/styles';
import { FontFamily } from '../../../theme/custom-theme';

export const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    backgroundColor: 'rgba(100,100,100,0.15)',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  title: {
    flexGrow: 1,
    fontSize: 10,
    color: 'white',
    fontFamily: FontFamily,
  },
}));
